import React from "react";

import styles from "./CreditRequestInstructions.module.less";
import { contentMap } from "./contentMap";

export const CreditRequestInstructions = ({
  reason,
  paymentProcessor = "stripe",
}) => {
  const Instruction =
    contentMap[paymentProcessor]?.[reason] ||
    contentMap[paymentProcessor]?.Other ||
    contentMap.other?.[reason] ||
    contentMap.other?.Other;

  return (
    <div className={styles.instructionsWrapper}>
      <div className={styles.instructions}>
        {Instruction && <Instruction />}
      </div>
    </div>
  );
};
